import { useDispatch } from 'react-redux';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import styles from './styles.module.scss';
import WithoutCategoryTag from '../../DashboardOverview/RowCards/components/WithoutCategoryTag';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function PropertyOrDevelopmentCell({
  isDevelopment = false,
  id,
  thumbnail,
  address,
  location,
  modal,
  withImage = true,
}) {
  const dispatch = useDispatch();
  const track = useTrackPerformanceTable();

  if (!id)
    return (
      <Box className={styles.propOrDevCell}>
        <WithoutCategoryTag
          text={Trans(translations, 'WithoutAssociatedProperty')}
        />
      </Box>
    );

  const handlePropOrDevClick = () => {
    dispatch(showQuickDisplay({ id, development: isDevelopment }));
    if (track[modal]) track[modal](TRACK_ELEMENT.PROPERTY_ADDRESS);
  };

  return (
    <Box
      className={styles.propOrDevCell}
      data-clickable
      onClick={handlePropOrDevClick}
    >
      {withImage && (
        <Box className={styles.propOrDevCellImageWrapper}>
          {thumbnail ? (
            <Box as="img" src={thumbnail} />
          ) : (
            <Icon
              icon="icon-propiedades"
              className={styles.propOrDevCellIcon}
            />
          )}
          {isDevelopment && (
            <Box className={styles.developmentIconWrapper}>
              <Icon
                className={styles.developmentIcon}
                icon="icon-emprendimientos"
              />
            </Box>
          )}
        </Box>
      )}

      <Box className={styles.propOrDevCellInformation}>
        <Text variant="body.fontSize15">{address}</Text>
        <Text variant="body.fontSize13">{location}</Text>
      </Box>
    </Box>
  );
}
